import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import CallToAction from '../../components/common/CallToAction';

class NotFound extends Component {
    render() {
        return (
            <div id="error-404" className="container-fluid">
                <div className="container d-flex flex-column justify-content-center align-items-center">
                    <h1>404</h1>
                    <h4>ขอโทษค่า ไม่พบหน้าที่คุณลูกค้าต้องการค่ะ</h4>
                    <h4><Link to="/">คลิกที่นี่</Link> เพื่อกลับหน้าหลักค่า</h4>
                </div>
                <CallToAction />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {}
}
export default connect(mapStateToProps, {})(NotFound)